import { PortFormRequestDto } from '@state';
import { portAnalysisApi } from './portAnalysisServiceApi';
import { PortAnalysisPortResponse } from '@state/types/PortAnalysisPortResponse';
import { PortPceAvailabilityResponse } from '@state/types/PortPceAvailabilityResponse';
import { PortAnalysisPortSearchResponse } from '@state/types/PortAnalysisPortSearchResponse';

const BASE_URL = '/secured/port';

const portAPI = portAnalysisApi.injectEndpoints({
  endpoints: (build) => ({
    fetchPort: build.query<PortAnalysisPortResponse, { portId: number }>({
      query: ({ portId }) => ({
        url: `${BASE_URL}/${portId}`,
        method: 'GET'
      }),
      providesTags: (res, _error, arg) =>
        res
          ? [{ type: 'PORT_ANALYSIS_PORT' as const, id: arg.portId }]
          : ['PORT_ANALYSIS_PORT']
    }),
    searchPort: build.query<
      PortAnalysisPortSearchResponse[],
      { portName: string }
    >({
      query: ({ portName }) => ({
        url: `${BASE_URL}/search`,
        params: { portName },
        method: 'GET'
      }),
      providesTags: ['PORT_ANALYSIS_PORT_SEARCH']
    }),
    savePort: build.mutation<PortAnalysisPortResponse, PortFormRequestDto>({
      query: (portData) => ({
        url: BASE_URL,
        method: 'POST',
        data: portData
      }),
      invalidatesTags: (res, _error, arg) => [
        res
          ? { type: 'PORT_ANALYSIS_PORT' as const, id: res.id }
          : 'PORT_ANALYSIS_PORT',
        'PORT_ANALYSIS_LOCATION',
        'PORT_ANALYSIS_PORT_SEARCH'
      ]
    }),
    pceAvailability: build.mutation<
      PortPceAvailabilityResponse,
      { portId: number; state: boolean }
    >({
      query: ({ portId, state }) => ({
        url: `${BASE_URL}/${portId}/available-in-pce`,
        method: 'PATCH',
        params: { state }
      }),
      invalidatesTags: (_res, _error, arg) => [
        { type: 'PORT_ANALYSIS_PORT' as const, id: arg.portId }
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useFetchPortQuery,
  useLazySearchPortQuery,
  useLazyFetchPortQuery,
  useSavePortMutation,
  usePceAvailabilityMutation
} = portAPI;
